import { INativeAdsConfiguration } from "@almamedia/amr-adtech-stack/lib/services/native/native-ads";
import { addTemplate } from "@almamedia/amr-adtech-stack/lib/services/native/native-helpers";
import { nativeLinkedInAd } from "@almamedia/amr-adtech-stack/lib/services/native/templates/native-linkedin-ad";
import nativeRectangleOrange from "@almamedia/amr-adtech-stack/lib/services/native/templates/native-rectangle-orange";

type SiteNativeTemplate = "native_linkedin_ad" | "native_rectangle_orange";

const nativeAds: INativeAdsConfiguration<SiteNativeTemplate> = {
  defaults: {
    nativeFields: {
      // renderer_id: 941,
      title: {
        required: true,
        max_length: 120,
      },
      body: {
        required: false,
        max_length: 150,
      },
      // body1: {
      //   required: false,
      // },
      image: {
        required: true,
        sizes: [
          {
            width: 1200,
            height: 628,
          },
          {
            width: 1200,
            height: 630,
          },
          {
            width: 1200,
            height: 675,
          },
          {
            width: 600,
            height: 314,
          },
          {
            width: 600,
            height: 315,
          },
          {
            width: 600,
            height: 338,
          },
          {
            width: 600,
            height: 450,
          },
          {
            width: 1200,
            height: 900,
          },
        ],
      },
      video: {
        required: false,
      },
      icon: {
        required: false,
        sizes: [],
      },
      sponsoredBy: {
        required: true,
        max_length: 50,
      },
      clickUrl: {
        required: true,
      },
      cta: {
        required: false,
      },
      displayUrl: {
        required: false,
      },
      desc2: {
        required: false,
      },
      privacySupported: true,
    },
  },
  templates: [
    addTemplate<SiteNativeTemplate>(nativeLinkedInAd),
    addTemplate<SiteNativeTemplate>(nativeRectangleOrange),
  ],
};

export default nativeAds;
export type { SiteNativeTemplate };
